
import { ActionType, getType } from 'typesafe-actions';

import * as config from '../../actionCreators/config';

export default function (
  state: PurchaserDetails[] = ['email', 'mobile'],
  action: ActionType<typeof config>,
): PurchaserDetails[] {
  switch (action.type) {
    case getType(config.setRequiredGuestPurchaserDetails): {
      const { value } = action.payload;
      return value || [];
    }
    default:
      return state;
  }
}
